import { useMutation } from '@tanstack/react-query';

import { fetchListFiveApi } from '../api';

export default function useListFiveMutation(options?: any) {
  return useMutation(fetchListFiveApi, options);
}
